import numeral from 'numeral';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IColumn } from '@feathr/components';
import { TableColumnHeader, Text } from '@feathr/components';

import type { IGoalRow } from './GoalsTable.utils';
import { goalTypeLabels } from './GoalsTable.utils';
import GoalsTargetCell from './GoalsTargetCell';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

export function GoalsTableColumns(): Array<IColumn<IGoalRow>> {
  const { t } = useTranslation();

  const columns: Array<IColumn<IGoalRow>> = [
    {
      id: 'name',
      Header: TableColumnHeader({ title: t('Name') }),
      checkboxLabel: t('Name'),
      className: tableStyles.cellLeft,
      Cell({ original }): JSX.Element {
        return <Text.DefaultHeadingMedium>{original.name}</Text.DefaultHeadingMedium>;
      },
    },
    {
      id: 'type',
      Header: TableColumnHeader({ title: t('Type') }),
      checkboxLabel: t('Type'),
      className: tableStyles.cellLeft,
      Cell({ original }): JSX.Element {
        return (
          <Text.DefaultRegular>
            {goalTypeLabels[original.type] || original.type}
          </Text.DefaultRegular>
        );
      },
    },
    {
      id: 'target',
      Header: TableColumnHeader({ title: t('Target') }),
      checkboxLabel: t('Target'),
      sortable: false,
      className: tableStyles.cellLeft,
      Cell({ original }): JSX.Element {
        if (!original.target) {
          return <Text.DefaultRegular>-</Text.DefaultRegular>;
        }
        return <GoalsTargetCell target={original.target} type={original.type} />;
      },
    },
    {
      id: 'conversions',
      Header: TableColumnHeader({ title: t('Conversions') }),
      checkboxLabel: t('Conversions'),
      className: tableStyles.cellRight,
      Cell({ original }): JSX.Element {
        return (
          <Text.DefaultRegular>{numeral(original.conversions).format('0,0')}</Text.DefaultRegular>
        );
      },
    },
    {
      id: 'conversionValue',
      Header: TableColumnHeader({ title: t('Conversion Value') }),
      checkboxLabel: t('Conversion Value'),
      className: tableStyles.cellRight,
      Cell({ original }): JSX.Element {
        if (original.conversionValue === 0 || original.isConversionSegment) {
          return <Text.DefaultRegular>-</Text.DefaultRegular>;
        }
        return (
          <Text.DefaultRegular>
            {numeral(original.conversionValue).format('$0,0.00')}
          </Text.DefaultRegular>
        );
      },
    },
  ];

  return columns;
}
